<script setup lang="ts">
import { defineEmits } from 'vue';
import DrawerBottom from '@/components/base/DrawerBottom.vue';
import type { MaterialV1 } from '@ilteducation/content-registry-types';
import { MaterialDetails } from '@ilteducation/components';

defineProps<{
  material: MaterialV1;
  materialsWithSameOriginalTitle: MaterialV1[];
  isDownloadLoading: boolean;
  isPrintLoading: boolean;
}>();
const emit = defineEmits<{
  (e: 'close'): [];
  (e: 'click-download'): void;
  (e: 'click-print'): void;
  (e: 'language-changed', newMaterial: MaterialV1): void;
}>();
const expanded = defineModel({
  default: false,
});

const onLanguageChanged = (newMaterial: MaterialV1) => {
  emit('language-changed', newMaterial);
};
</script>

<template>
  <DrawerBottom :expanded="expanded" @close="emit('close')" :extra-classes="['pa-0']">
    <MaterialDetails
      :material="material"
      :materials-with-same-original-title="materialsWithSameOriginalTitle as MaterialV1[]"
      :is-download-loading="isDownloadLoading"
      :is-print-loading="isPrintLoading"
      @click-download="emit('click-download')"
      @click-print="emit('click-print')"
      @language-changed="onLanguageChanged"
    ></MaterialDetails>
  </DrawerBottom>
</template>

<style scoped lang="scss"></style>
